let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e3rNQ")).then(() => parcelRequire('g9737'));